/**
 * ms between sending keepalive to server
 */
export const KEPP_ALIVE = 60000;

/**
 * ms timeout if no keepalive response
 */
export const LIFETIME = 180000;

/**
 * format of `data`
 */
export const DATA_MIME_TYPE = 'application/json';

/**
 * format of `metadata`
 */
export const METADATA_MIME_TYPE = 'message/x.rsocket.routing.v0';

/**
 * Transport url for rsocket
 */
export const RSOCKET_TRANSPORT_URL = `${process.env.NEXT_PUBLIC_APP_API_SHOP_OPERATIONS_WEBSOCKET_URL}/rsocket`;

/**
 * Retry delay before reconnect
 */
export const RETRY_DELAY = 5000;
